import crud from './helpers/crud';

// Loads the org's Elation report-delegation config plus the synced physicians,
// users, and staff groups the settings UI picks from.
const credentialQuery = (credentialId) => (
  credentialId ? `?emr_integration_credential_id=${encodeURIComponent(credentialId)}` : ''
);

const getElationRouting = (credentialId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_GET_ELATION_ROUTING',
      fail: 'FAILED_GET_ELATION_ROUTING',
      end: 'FINISH_GET_ELATION_ROUTING',
    },
    method: 'GET',
    url: `/api/v1/elation_routing${credentialQuery(credentialId)}`,
  })
);

// Replaces the delegation config wholesale.
const updateElationRouting = (delegation, credentialId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_UPDATE_ELATION_ROUTING',
      fail: 'FAILED_UPDATE_ELATION_ROUTING',
      end: 'FINISH_UPDATE_ELATION_ROUTING',
    },
    method: 'PUT',
    url: `/api/v1/elation_routing${credentialQuery(credentialId)}`,
    data: { delegation },
  })
);

// Re-syncs physicians, users, and staff groups from Elation.
const refreshElationRouting = (credentialId) => (
  crud({
    dispatch: {
      begin: 'BEGIN_REFRESH_ELATION_ROUTING',
      fail: 'FAILED_REFRESH_ELATION_ROUTING',
      end: 'FINISH_REFRESH_ELATION_ROUTING',
    },
    method: 'POST',
    url: `/api/v1/elation_routing/refresh${credentialQuery(credentialId)}`,
  })
);

export { getElationRouting, updateElationRouting, refreshElationRouting };
